import { render } from "./RuiMenuOpen.vue?vue&type=template&id=ce7a8f44"
const script = {}
script.render = render

export default script